import { Checkbox, Flex, Input, ProviderConsumer, SearchIcon } from "@fluentui/react-northstar"
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { RenderThemedTable, tableGetRows, tableMoveToPage, tableOnSearch, tableSearchedResult } from "../../../shared/components/table/TableWrapper";
import useCurrentPage from "../../../kb/useCurrentPage";
import { useTranslation } from "react-i18next";
import { DATASOURCE_HEADERS, FILTERS_STRINGS, LICENSE_FEATURE } from "../../../shared/utils/constants";
import { platformService } from "../../../shared/services/platform.service";
import { TemplatePickerBaseProps } from "./DataSourceForm";
import Styles from './datasource.module.css';
import { getCachedFeature } from "../../../shared/cache/FeatureCache";
import { ISupportGroup, ITeam } from "../../../shared/interfaces/supportGroup.interface";

interface IDataSourceOption {
  Id: number,
  Name: string
}

interface Props{
  dataSourceProps?: TemplatePickerBaseProps;
}

export const DataSourceOptionsList = ({dataSourceProps}: Props) => {

  const { t } = useTranslation();
  const api = new platformService();
  const [searchKey1, setSearchKey1] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [collection, setCollection] = useState<RowsData[]>([]); // could be searched result or original data passed as prop
  const [rows, setRows] = useState<RowsData[]>([]);
  const {currentPage, setCurrentPage} = useCurrentPage();
  const $tableWrapper = useRef<HTMLDivElement | null>(null);

  const headers: string[] = ["checkbox", DATASOURCE_HEADERS[0]];

  const fetchTags = async () => {
    let values: IDataSourceOption[] = [];
    const enabledTicketTags = await getCachedFeature(LICENSE_FEATURE.TicketTags);
    if(enabledTicketTags) {
      let value = await api.getTags(`${FILTERS_STRINGS.DELETE_FALSE}&$count=true&v=${new Date().getTime()}`);
      values = value.map((tag: TagsData) => {
        return { Id: tag.Id, Name: tag.Name } as IDataSourceOption;
      });
    }
    return values;
  }

  const fetchTeams = async () => {
    let values: IDataSourceOption[] = [];
    const enabledTeams= await getCachedFeature(LICENSE_FEATURE.MultiDepartment);
    if(enabledTeams) {
      const { data: { value } }  = await api.getTeams('?$orderby=FriendlyName');
      values = value?.map((team: ITeam) => {
        return { Id: team.Id, Name: team.FriendlyName } as IDataSourceOption;
      }) ?? [];
    }
    return values;
  }

  const fetchGroups = async () => {
    const { data: { value } }  = await api.getSupportGroups('?$orderby=Name');
    let values: IDataSourceOption[] = value?.map((group: ISupportGroup) => {
      return { Id: group.Id, Name: group.Name } as IDataSourceOption;
    }) ?? [];

    return values;
  }

  const fetchData = useCallback(async () => {
      try {
        let values: IDataSourceOption[] = [];
        if(dataSourceProps.dataSourceData?.EntityType == "Tag")
          values = await fetchTags();
        else if(dataSourceProps.dataSourceData?.EntityType == "Team")
          values = await fetchTeams();
        else if(dataSourceProps.dataSourceData?.EntityType == "SupportGroup")
          values = await fetchGroups();
        const rowData: RowsData[] = values.map((ds: IDataSourceOption) => ({
          id: ds.Id,
          ["checkbox"]: (<Checkbox className={`${Styles.selectorCheckbox}`}
            checked={dataSourceProps?.dataSourceData?.SelectedValues?.includes(ds.Id.toString()) ?? false}
            onChange={(_e, data) => dataSourceProps.onAddRemoveFromDataSource(ds, data.checked, "Id")}
          />),
          [t('template.datasource-headers.name-search')]: ds.Name,
          [t('template.datasource-headers.name')]: ds.Name
        }));
  
        setRows(rowData);
      } catch (err: any) {
      }
    }, []);

    const updateRows = () => {
      try {
       const rowData: RowsData[] = rows.map(ds => {
          let dsIdString = (typeof ds.id === 'number' || typeof ds.id === 'string') ? ds.id.toString() : "";
          const checkedVar = dataSourceProps?.dataSourceData?.SelectedValues?.includes(dsIdString) ?? false;
          ds["checkbox"] = (<Checkbox className={`${Styles.selectorCheckbox}`}
            checked={checkedVar}
            onChange={(_e, data) => dataSourceProps.onAddRemoveFromDataSource(ds, data.checked)}
          />);
          return ds;
       });
        setRows(rowData);
      } catch (err: any) {
      }
    };

    useEffect(() => {
        fetchData();
    }, [])

    useEffect(() => {
      updateRows();
    }, [dataSourceProps?.dataSourceData])
  
  
    const searchedResult1 = (val: string) => {
      tableSearchedResult(setCollection, rows, val);
    }
  
    useEffect(() => {
      searchedResult1(searchKey1);
    }, [searchKey1, rows]);

    const getRows1 = useMemo(() => (): RowListObject[] => {
        return tableGetRows(collection, headers, () => {}, `${Styles.dsTableRow}`);
      }, [collection]);
  
    const onSearch1 = (e: React.SyntheticEvent<HTMLElement>) => {
      tableOnSearch(setSearchKey1, searchedResult1, setCurrentPage, e);
    }

  return <ProviderConsumer
      render={globalTheme => (
      <>
          <Flex column gap='gap.medium'>
              <Flex style={{ justifyContent: 'flex-end' }}>
                  <Input
                      icon={<SearchIcon />}
                      inverted
                      placeholder={t('common.search')}
                      value={searchKey1}
                      onChange={onSearch1}
                  />
              </Flex>

          <RenderThemedTable 
            globalTheme={globalTheme} 
            $tableWrapper={$tableWrapper} 
            headers={[]} 
            headerNotTitleCase={false} 
            getRows={getRows1}
          />
          </Flex>
      </>
      )}
  />
}